import styled from 'styled-components';

import colors from 'themes/Main';

const { blue, darkBlue } = colors;

export const Container = styled.div`
  padding: 64px 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  ${({ isFull }) =>
    isFull &&
    `
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    background-color: rgba(255,255,255, .7);
  `}

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  p {
    margin: 16px 0 0;
    font-weight: 700;
    color: ${darkBlue};
    text-transform: uppercase;
    font-size: 14px;
    opacity: 0.5;
  }

  .loader {
    width: ${({ width }) => `${width}px`};
    height: ${({ height }) => `${height}px`};
    border-radius: 100px;
    border: 3px solid ${blue};

    transform-origin: 50% 50%;
    animation: loader 2s linear infinite;

    &::after {
      content: '';
      position: absolute;
      top: -5px;
      left: 20px;
      width: 11px;
      height: 11px;
      border-radius: 10px;
      background-color: ${darkBlue};
    }
  }

  @keyframes loader {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
